<template>
    <div>
        <h1>PrintScreen</h1>
        <el-button @click="screenShot()">Screenshot</el-button>
        <div ref="screen">
            <p>html2canvas screenshot</p>
            <p>html2canvas screenshot</p>
            <p>html2canvas screenshot</p>
            <p>html2canvas screenshot</p>
            <p>html2canvas screenshot</p>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import html2canvas from "html2canvas"

export default {
    mounted() {},
    ...mapMutations(["mutateMiniSidebar"]),
    methods: {
        screenShot() {
            html2canvas(this.$refs.screen, {
                font: "#FFFFFF",
                backgroundColor: "#000000",
                useCORS: true,
            }).then((canvas) => {
                if (navigator.msSaveBlob) {
                    // IE10+
                    let blob = canvas.msToBlob()
                    return navigator.msSaveBlob(blob, name)
                } else {
                    let imageurl = canvas.toDataURL("image/png")
                    // console.log(imageurl, "hhhd");
                    //You need to choose the naming rules yourself
                    let imagename = ""
                    this.fileDownload(imageurl, imagename)
                }
            })
        },
        //Download screenshot pictures
        fileDownload(downloadUrl, downloadName) {
            let aLink = document.createElement("a")
            // console.log(aLink, "ghh");
            aLink.style.display = "none"
            aLink.href = downloadUrl
            aLink.download = `${downloadName}Test.png`
            // Trigger click-then remove
            document.body.appendChild(aLink)
            aLink.click()
            document.body.removeChild(aLink)
        },
    },
    data() {
        return {}
    },
}
</script>
